{
  "title": "Проекты",
  "empty": "Проектов пока нет",
  "emptyLead": "Подключите проект Hetzner Cloud, чтобы управлять им здесь.",
  "add": "Подключить проект",
  "name": "Название проекта",
  "token": "API-токен",
  "tokenHelp": "В Hetzner Console откройте проект, Security → API tokens, создайте токен Read & Write и вставьте его сюда. Он хранится в зашифрованном виде и больше не показывается.",
  "submit": "Подключить",
  "switcher": "Сменить проект",
  "status": {
    "active": "Подключён",
    "failing": "Провайдер недоступен",
    "revoked": "Токен отклонён"
  },
  "permission": {
    "read": "Только чтение",
    "read_write": "Чтение и запись"
  },
  "token_hint": "Токен …{{hint}}",
  "synced": "Каталог обновлён {{date}}",
  "neverSynced": "Каталог ещё не загружен",
  "refresh": "Обновить каталог",
  "replaceToken": "Заменить токен",
  "forget": "Убрать из CloudServer",
  "intro": "Каждый проект здесь — это один проект Hetzner Cloud, подключённый своим токеном API. Откройте проект, чтобы видеть и менять то, что в нём работает.",
  "all": "Все проекты",
  "addLead": "Вставьте токен API проекта Hetzner Cloud. CloudServer проверит его перед сохранением.",
  "nameHint": "Как проект называется в CloudServer; не обязательно так же, как в Hetzner.",
  "tokenWhy": "Токен Hetzner принадлежит одному проекту, поэтому каждый проект подключается своим токеном.",
  "connected": "Проект «{{name}}» подключён",
  "state": "Подключение",
  "catalogue": "Каталог",
  "open": "Открыть",
  "refreshed": "Каталог «{{name}}» обновлён",
  "forgetTitle": "Удалить «{{name}}» из CloudServer?",
  "forgetToken": "CloudServer забудет токен API и всё, что сохранил об этом проекте.",
  "forgetKeep": "В Hetzner ничего не удаляется: серверы, IP и данные продолжат работать.",
  "forgetBilling": "Hetzner продолжит брать за них деньги; если они не нужны, сначала удалите их.",
  "forgotten": "Проект «{{name}}» удалён из CloudServer",
  "emptyMember": "Проектов для вас пока нет",
  "emptyMemberLead": "Доступ к проектам выдаёт администратор. Попросите его — и проекты появятся здесь."
}
